import { Alert, Autocomplete, Box, Button, Card, Dropdown, IconButton, Input, Menu, MenuButton, MenuItem, Table, Tooltip, Typography } from '@mui/joy';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { post, Token, url } from '../../../../../Script/Session';
import MoreVert from '@mui/icons-material/MoreVert';
import PlaylistAddCheckCircleRoundedIcon from '@mui/icons-material/PlaylistAddCheckCircleRounded';
import Upload from '@mui/icons-material/Upload';
function TarifStanddateienEditor() {
    const { additional, subkath, type } = useParams();
    const [data, setdata] = useState();
    const [changestate, setchangestate] = useState("none");
    const [currentdateiedit, setcurrentdateiedit] = useState();
    const [nameinputval, setnameinputval] = useState();
    const [alert, setalert] = useState(false);
    const [kathdata, setkathdata] = useState();
    const [types, settypes] = useState([]);
    const [selectedtype, setselectedtype] = useState();
    const [createdatei, setcreatedatei] = useState(false);
    const [file, setf] = useState(null);
    const navigate = useNavigate();
    useEffect(() => {
        let body = {
            token: Token.get(),
            action: "get",
            targetid: Number(additional),
        };

        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }

        const parsed = JSON.parse(response);
        setdata(parsed);

        const b1 = {
            token: Token.get(),
            action: "get",
            target: Number(subkath)

        };
        let re = post(b1, "/vergleiche/sub-sparten");
        const prased = JSON.parse(re);
        setkathdata(prased);
        console.log(re)
        let a = [];
        Object.keys(prased.pflichtdateien).map((dateiname, index) => {
            a.push(dateiname);
        })
        if (type === "konzept") {
            Object.keys(prased.kontextpflichtdateien).map((dateiname, index) => {
                a.push(dateiname);
            })
        }
        if (type === "empfehlung") {
            Object.keys(prased.empfelungspflichtdateien).map((dateiname, index) => {
                a.push(dateiname);
            })
        }
        settypes(a);

    }, []);
    function update() {
        let body = {
            token: Token.get(),
            action: "get",
            targetid: Number(additional),
        };

        let response = post(body, "/tarife/tarifstand");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }

        const parsed = JSON.parse(response);
        setdata(parsed);
    }
    function updatename() {
        let body = {};
        body.token = Token.get();
        body.action = "rename";
        body.objectid = currentdateiedit.id;
        body.tarifstandid = Number(additional);
        body.newname = nameinputval;
        let response = post(body, "/tarife/edit_tarif_stand_dateien");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            update();
            setalert(true);
            setchangestate("none");
            setcurrentdateiedit(null);
        }
    }
    function updatetype() {
        if (!selectedtype) {
            return;
        }
        let body = {};
        body.token = Token.get();
        body.action = "typechange";
        body.objectid = currentdateiedit.id;
        body.tarifstandid = Number(additional);
        body.newtype = selectedtype;
        let response = post(body, "/tarife/edit_tarif_stand_dateien");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            update();
            setselectedtype(null);
            setalert(true);
            setchangestate("none");
            setcurrentdateiedit(null);
        }
    }
    function deletefile(i) {
        let body = {};
        body.token = Token.get();
        body.action = "delete";
        body.objectid = i.id;
        body.tarifstandid = Number(additional);
        let response = post(body, "/tarife/edit_tarif_stand_dateien");
        if (response === "LOGOUT") {
            navigate("/");
            return;
        }
        if (response == "OK") {
            update();
            setalert(true);
            setcurrentdateiedit(null);
        }
    }
    function handleChange(e) {
        const f = e.target.files[0];
        if (f) setf(f);
    }

    function adddatei() {
        if (!file) return;
        if (!selectedtype) {
            console.log("Missing type");
            return;
        }

        const formData = new FormData();
        const body = {
            token: Token.get(),
            action: "adddata",
            tarifstandid: Number(additional),
            newtype: selectedtype,
            name: nameinputval,
        };

        formData.append("json", JSON.stringify(body));
        formData.append("file", file);

        fetch(url + "/api/tarife/edit_tarif_stand_files", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                    setcreatedatei(false);
                    setnameinputval("");
                    setselectedtype(null);
                    setf(null);
                    setalert(true);
                }
            })
            .catch(console.error);
    }
    function changedatei() {
        if (!file) return;
        const formData = new FormData();
        const body = {
            token: Token.get(),
            action: "replacedata",
            tarifstandid: Number(additional),
            objectid: currentdateiedit.id,
        };

        formData.append("json", JSON.stringify(body));
        formData.append("file", file);

        fetch(url + "/api/tarife/edit_tarif_stand_files", {
            method: "POST",
            body: formData,
        })
            .then(res => res.text())
            .then(text => {
                console.log(text);
                if (text === "OK") {
                    update();
                    setcreatedatei(false);
                    setnameinputval("");
                    setselectedtype(null);
                    setf(null);
                    setalert(true);
                    setchangestate("");
                }
            })
            .catch(console.error);
    }
    return (
        <Box
            sx={{
                width: "100vw",     // pixel-based width
                p: 2,
                boxSizing: "border-box",
                bgcolor: "white",
                mx: "auto",           // center horizontally
                display: "flex",
                flexDirection: "column",
                overflowY: "auto",
            }}
        >
            <Card variant='soft' sx={{ mb: 3 }}>
                <Box>
                    <Typography level="title-md">Hinweis</Typography>
                    <Typography>Dateien die neu hinzugefügt oder ersetzt werden, werden automatisch als geprüft angesehen.</Typography>
                    <Typography>Bei ersetzen Dateien werden die Prüfungen übernommen.</Typography>
                </Box>
            </Card>

            {
                alert && (
                    <Alert
                        sx={{ mb: 5 }}
                        variant="soft"
                        color="success"
                        startDecorator={<PlaylistAddCheckCircleRoundedIcon />}
                        endDecorator={
                            <Button size="sm" variant="solid" color="success" onClick={() => setalert(false)}>
                                Schliesen
                            </Button>
                        }
                    >
                        Ihre änderungen wurden Erfolgreich gespeichert.
                    </Alert>
                )
            }
            {
                changestate == "change" && (
                    <Card variant='soft' sx={{ mb: 3 }}>
                        <Box>
                            <Typography level="title-md">Datei ersetzen</Typography>
                            <Typography>Bitte geben sie eine neue Datei an</Typography>
                        </Box>
                        <Typography>Ausgewählte Datei:{file ? ` ${file.name}` : " Keine"}</Typography>
                        <input
                            type="file"
                            id="file-upload"
                            style={{ display: 'none' }}
                            onChange={handleChange}
                        />
                        <label htmlFor="file-upload">
                            <Tooltip title="Datei auswählen">
                                <IconButton component="span" variant="soft" color="primary">
                                    <Upload />
                                    <Typography sx={{ ml: 1 }}>Datei auswählen</Typography>
                                </IconButton>
                            </Tooltip>
                        </label>
                        <Button onClick={() => changedatei()} sx={{ width: "7%" }}>
                            Speichern
                        </Button>

                    </Card>
                )
            }
            {
                createdatei && (
                    <Card variant='soft' sx={{ mb: 3 }}>
                        <Box>
                            <Typography level="title-md">Datei erstellen</Typography>
                            <Typography>Bitte geben sie den Namen der datei an</Typography>
                        </Box>
                        <Input placeholder='Neuer Name' value={nameinputval} onChange={(e) => setnameinputval(e.target.value)} sx={{ width: "25%" }}></Input>
                        <Autocomplete value={selectedtype} options={types} onChange={(e, nv) => setselectedtype(nv)} sx={{ width: "25%" }} />
                        <Typography>Ausgewählte Datei:{file ? ` ${file.name}` : " Keine"}</Typography>
                        <input
                            type="file"
                            id="file-upload"
                            style={{ display: 'none' }}
                            onChange={handleChange}
                        />
                        <label htmlFor="file-upload">
                            <Tooltip title="Datei auswählen">
                                <IconButton component="span" variant="soft" color="primary">
                                    <Upload />
                                    <Typography sx={{ ml: 1 }}>Datei auswählen</Typography>
                                </IconButton>
                            </Tooltip>
                        </label>
                        <Button onClick={() => adddatei()} sx={{ width: "7%" }}>
                            Speichern
                        </Button>
                    </Card>
                )
            }
            {
                changestate == "name" && (
                    <Card variant='soft' sx={{ mb: 3 }}>
                        <Box>
                            <Typography level="title-md">Dateiname ändern</Typography>
                            <Typography>Bitte geben sie den neuen Namen der datei an</Typography>
                        </Box>
                        <Input placeholder='Neuer Name' value={nameinputval} onChange={(e) => setnameinputval(e.target.value)} sx={{ width: "25%" }}></Input>
                        <Button onClick={() => updatename()} sx={{ width: "7%" }}>
                            Speichern
                        </Button>
                    </Card>
                )
            }
            {
                changestate == "type" && (
                    <Card variant='soft' sx={{ mb: 3 }}>
                        <Box>
                            <Typography level="title-md">Dateityp ändern</Typography>
                            <Typography>Bitte geben sie den neuen Typ der datei an</Typography>
                        </Box>
                        <Autocomplete value={selectedtype} options={types} onChange={(e, nv) => setselectedtype(nv)} sx={{ width: "20%" }} />
                        <Button onClick={() => updatetype()} sx={{ width: "7%" }}>
                            Speichern
                        </Button>
                    </Card>

                )
            }
            <Card variant='soft' sx={{ display: "flex", mx: "auto", }}>
                <Box sx={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <Box>
                        <Typography level="title-md">Dateien</Typography>
                        <Typography>Hier können sie änderungen an den Tarifstanddateien vornehmen</Typography>
                    </Box>
                    <Box sx={{ display: "flex", flexDirection: "row", width: "15%", gap: 2 }}>
                        <Button onClick={() => {
                            window.open('', '_self');
                            window.close();
                        }} sx={{ width: "40%", height: "5%" }}>
                            Schliesen
                        </Button>
                        <Button onClick={() => { setcreatedatei(true); setchangestate("none") }} sx={{ width: "60%", height: "5%" }}>
                            Datei Hinzufügen
                        </Button>
                    </Box>

                </Box>

                <Table>
                    <thead>
                        <tr>
                            <th>Dateiname</th>
                            <th>Typ</th>
                            <th>Endung</th>
                            <th>Größe</th>
                            <th>Sonstiges</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data && data.pflichtdateien.map(item => (
                            <tr key={item.id}>
                                <td>{item.anzeigename}</td>
                                <td>{item.type}</td>
                                <td>.{item.name.split(".")[1]}</td>
                                <td>{item.size.toString().split(".")[0]} Kilobyte</td>
                                <td>
                                    <Dropdown>
                                        <MenuButton
                                            slots={{ root: IconButton }}
                                            slotProps={{ root: { variant: 'outlined', color: 'neutral' } }}
                                        >
                                            <MoreVert />
                                        </MenuButton>
                                        <Menu>
                                            <MenuItem onClick={() => { setcreatedatei(false); setchangestate("change"); setcurrentdateiedit(item); setf(null) }}>Datei ersetzen</MenuItem>
                                            <MenuItem onClick={() => { setchangestate("name"); setcurrentdateiedit(item); setnameinputval(item.anzeigename) }}>Name ändern</MenuItem>
                                            <MenuItem onClick={() => {
                                                setchangestate("type");
                                                setcurrentdateiedit(item);
                                            }}>Typ ändern</MenuItem>
                                            <MenuItem sx={{ color: "red" }} onClick={
                                                () => {

                                                    deletefile(item);

                                                }
                                            }>Datei Löschen</MenuItem>
                                        </Menu>
                                    </Dropdown>

                                </td>
                            </tr>
                        ))}
                    </tbody>



                </Table>

            </Card>




        </Box>
    )
}

export default TarifStanddateienEditor
